module.exports = __webpack_public_path__ + "img/1f399.c1f1dbf.svg";